import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UploadCoverService } from '../../providers/Table/uploadCover.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Globals } from '../../ressources/variables/globals';

@Component({
  selector: 'app-coverupload',
  templateUrl: './coverUpload.component.html',
  styleUrls: ['./coverUpload.component.scss']
})
export class CoverUploadComponent implements OnInit, OnDestroy {
  dataOut = {
    startRow: 0,
    endRow: 0,
    cover: '',
    edit: false
  };
  loading = false;

  constructor(private uploadCoverService: UploadCoverService,
              @Inject(MAT_DIALOG_DATA) private dataIn,
              private dialogRef: MatDialogRef<any>) {}

  ngOnInit() {
    this.dataOut.startRow = this.dataIn.startRow;
    this.dataOut.endRow = this.dataIn.endRow;
  }

  ngOnDestroy() {
    console.log('destroy');
  }

  envoiFichier (fichiers: FileList) {
    this.loading = true;
    this.uploadCoverService.envoiFichier(fichiers.item(0))
      .then(res => {
        this.dataOut.cover = Globals.appLocation + '/cover_import/' + res.replace(/'/g, '');
        this.dataOut.edit = true;
        this.loading = false;
      })
      .catch(() => this.loading = false);
  }

  closeDialog(send: boolean): void {
    if (send === false || this.dataOut.edit === false) {
      this.dialogRef.close(undefined);
    } else {
      this.dialogRef.close(this.dataOut);
    }
  }

}
